<markdown 
  class="markdown" 
  [class.is-inline]="isInline"
  [class.is-condensed]="isCondensed" 
  [data]="val" 
  ngPreserveWhitespaces
></markdown>